import RoutesComponent from "../../routes";
import Header from "../Header";
import SideBar from "../SideBar";
import { StyledLayout } from "./styles";

function Layout() {
    return <StyledLayout>
        <SideBar />
        <main>
            <Header />
            <RoutesComponent />
        </main>
    </StyledLayout>
}

export default Layout;